var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgKlaviyo = function SvgKlaviyo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 206.4 137.7",
    style: {
      enableBackground: "new 0 0 206.4 137.7"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.klaviyosvg{fill:#232426;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "klaviyosvg",
    d: "M205.5,1.4c-2.2,3.6-4.4,7.3-6.7,10.8c-4.9,7.8-9.9,15.6-14.7,23.4c-6.7,10.6-13.4,21.3-20.1,31.9 c-0.6,0.9-0.9,1.7-0.1,2.9c4.9,7.7,9.7,15.4,14.7,23.1c5.7,9.1,11.4,18.3,17.3,27.4c3.2,5.2,6.5,10.3,9.7,15.4c0,0,0,0.1,0.1,0.1 c-0.4,0.5-0.5,0.8-0.8,1.3c-0.3,0-0.4,0-0.6,0c-67.4,0-134.7,0-202.2,0c-0.4,0-0.6,0-1,0c-0.4-0.4-0.5-0.5-0.9-0.9 c0-0.3,0-0.5,0-0.9C0,91.3,0,46.5,0,1.8c0-0.3,0-0.5,0-0.9C0.4,0.5,0.5,0.4,0.9,0c0.4,0,0.6,0,1,0c67.4,0,134.9,0,202.2,0 c0.3,0,0.4,0,0.6,0C205.1,0.6,205.2,0.9,205.5,1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.4,137.7c-0.4,0-0.6-0.3-0.6-0.6l0,0C206,137.2,206.1,137.3,206.4,137.7L206.4,137.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.1,0.5c-0.1-0.1-0.3-0.3-0.4-0.3c0.1,0,0.4,0.1,0.5,0.1C206.1,0.4,206.1,0.4,206.1,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.3,0.1C0.1,0.3,0.1,0.3,0,0.4C0.1,0.4,0.3,0.3,0.3,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,137.5c0.1,0.1,0.1,0.1,0.3,0.3C0.3,137.6,0.1,137.5,0,137.5z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKlaviyo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "klaviyo.f2471cac973273b8766d16b8a6b3e96c.svg";